import { useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
    Grid,
    Stack,
    Button,
    Typography,
    IconButton,
} from "@mui/material";
//Icons  
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import SchoolLogo from "../../Assets/logoReport.png"
import SymbolLogo from "../../Assets/symbol.jpg";
import { getKhmerNumber } from "../../Function/DynamicFn";

export default function PrintPlan({ open, handleClose, editData }) {
    // Change Language
    const [loading, setLoading] = useState(false)

    const startYear = editData?.academicYearId?.academicYearInKhmer?.slice(0, 4);
    const endYear = editData?.academicYearId?.academicYearInKhmer?.slice(5, 9);

    // const tableData = [1, 2, 3]

    return (
        <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
            <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
                <Stack direction="row" justifyContent="space-between">
                    <Stack direction="column" justifyContent="center">
                        <Typography className="dialog-title">
                            បោះពុម្ភផែនការ
                        </Typography>
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                        <IconButton onClick={handleClose}>
                            <BiMinusCircle className="close-icon" />
                        </IconButton>
                    </Stack>
                </Stack>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12}>
                        <Stack direction="column" spacing={1}>
                            <Stack direction="row" width="100%">
                                <Stack justifyContent="center" width="20%">
                                    <img src={SchoolLogo} width="100px" alt="Logo" />
                                </Stack>
                                <Stack direction="column" spacing={4} width="75%">
                                    <Stack width="80%" justifyContent="center" alignItems="center">
                                        <Typography className="cam-titel-kh">
                                            ព្រះរាជាណាចក្រកម្ពុជា
                                        </Typography>
                                        <Typography className="cam-titel-en">
                                            Kingdom Of Cambodia
                                        </Typography>
                                        <Typography className="cam-titel-kh">
                                            ជាតិ សាសនា ព្រះមហាក្សត្រ
                                        </Typography>
                                        <Typography className="cam-titel-en">Nation Region King</Typography>
                                        <img src={SymbolLogo} alt="" width="120px" />
                                    </Stack>
                                </Stack>
                            </Stack>
                            <Typography className="cam-titel-kh" sx={{ textAlign: "center" }}>
                                របាយការណ៍សម្ភារៈសម្រាប់ ឆ្នាំសិក្សា {getKhmerNumber(startYear)}-{getKhmerNumber(endYear)}
                            </Typography>
                            <table className="inventory-report-table-container">
                                <thead>
                                    <tr>
                                        <th style={{ width: "4%" }}>ល.រ</th>
                                        <th style={{ width: "36%" }}>សម្ភារៈ</th>
                                        <th style={{ width: "20%" }}>ខ្នាត</th>
                                        <th style={{ width: "10%" }}>ផែនការ</th>
                                        <th style={{ width: "10%" }}>ជាក់ស្ដែង</th>
                                        <th style={{ width: "20%" }}>លម្អៀង</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr style={{ backgroundColor: "#EEECE1", fontWeight: "bold", textAlign: "center" }}>
                                        <td colSpan={"2"} style={{ color: "#0000FF" }}>សរុប</td>
                                        <td style={{ color: "red" }}></td>
                                        <td style={{ color: "red" }}></td>
                                        <td style={{ color: "red" }}></td>
                                        <td style={{ color: "red" }}></td>
                                    </tr>
                                    {editData?.items?.map((row, index) => {
                                        // console.log("row::", row)
                                        return (
                                            <tr key={index}>
                                                <td align="center">{index + 1}</td>
                                                <td>{row?.listMaterialUnitId?.materialId?.materialKhName}</td>
                                                <td align="center">
                                                    {row?.listMaterialUnitId?.unitId?.unitKhName}
                                                </td>
                                                <td align="center">
                                                    {row?.qty}
                                                </td>
                                                <td align="center">
                                                    {row?.qty}
                                                </td>
                                                <td align="center">
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        {loading ? (
                            <Button className="btn-create" fullWidth>
                                កំពុងដំណើរការ...
                            </Button>
                        ) : (
                            <Button
                                className="btn-create"
                                fullWidth
                            >
                                បោះពុម្ភ
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
